<form (submit)="onSubmit()" class="step-form" [formGroup]="form" #stepForm>
  @if (headlineTextkey) {
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [innerHTML]="headlineTextkey | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
    </div>
  }

  <div class="grid-x grid-margin-x">
    @if (hasHelp) {
      <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
        <button type="button" [attr.aria-expanded]="showPageHelp" [attr.aria-controls]="" class="help-toggle hide-for-medium" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
        @if (helpTextkey) {
          <div class="callout lighter-gray step-help" [class.show]="showPageHelp">
            <div [innerHTML]="helpTextkey | translate"></div>
            @if (hasInlineHelp) {
              <button type="button" [attr.aria-expanded]="showInlineHelp" [attr.aria-controls]="" (click)="toggleInlineHelp()" class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</button>
            }
          </div>
        }
      </div>
    }
    <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1">
      <h2 id="field-group" class="field-group-headline" [innerHTML]="textkeyPrefix + '.shower.verbrauchsdaten.headline' | translate"></h2>
      @if (formError) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.step.error.' + formError | translate: stepErrorPlaceholder || {fallback: 'step.error.' + formError}"></p>
        </div>
      }
      @if (formWarning) {
        <div role="alert" class="form-warnings">
          <p [innerHTML]="textkeyPrefix + '.step.warning.' + formWarning | translate"></p>
        </div>
      }
      @for (field of showerFields; track field; let fieldIndex = $index) {
        <div formfield aria-labelledby="field-group" [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix" class="shower formfield"></div>
      }

    </div>
  </div>

  <app-step-buttons [nextClass]="loading? 'loading' : ''" [previousLink]="previousStep? previousStep.path : null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextDisabled]="!form.valid" (onNextClick)="submitClicked()"></app-step-buttons>
</form>
